import { type FC } from "react";
import { EditPageLink } from "@legacy_user_frontend/components/pages/mypage/profiles/profiles_show/src/ui_parts/edit_page_link";
import * as styles from "./styles.css";

export type HeadingProps = {
  text: string;
  editPath?: string;
};

export const Heading: FC<HeadingProps> = ({ text, editPath }) => (
  <div className={styles.headingOuter}>
    <h2 className={styles.heading}>{text}</h2>
    {editPath && (
      <div className={styles.editPageLinkOuter}>
        <EditPageLink url={editPath} />
      </div>
    )}
  </div>
);
